import React, { useEffect, useState, useContext } from "react";
import {
  Container,
  Button,
  Col,
  Breadcrumb,
  Card,
  Badge,
  Row,
  Dropdown,
  Modal,
  Form,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import axios from "axios";
import Loader from "../../components/Loader.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDisplay,
  faPlus,
  faPersonChalkboard,
  faAddressCard,
  faClose,
  faClone,
  faSquarePlus,
  faFilter,
  faCircleCheck,
  faDiamond,
  faExternalLinkAlt,
  faUser,
  faBell,
  faExclamationTriangle,
  faImage,
  faBuilding,
  faRotateLeft,
  faSync,
  faEnvelope,
  faListCheck,
  faStore,
  faUserXmark,
  faVideo,
} from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";
import { domainConfig } from "../../config.js";
import illustration from "../../assets/img/illustrations/curiosity search-bro.png";
import imageNotFound from "../../assets/img/image-not-found.png";
import NotyfContext from "../../contexts/NotyfContext.js";
import useAppSelector from "../../hooks/useAppSelector.js";
import useAppDispatch from "../../hooks/useAppDispatch.js";
import useAuth from "../../hooks/useAuth.js";
import useLayout from "../../hooks/useLayout.js";
import {
  eventX,
  colorsX,
  statusX,
  handleDelete,
  registerToggle,
  handleEndEvent,
} from "../../components/EventsComponents.js";
import { CustomizationModal } from "../../components/EventsComponents01.js";
import {
  setID,
  resetEventsOpenedFull,
  setCurrentPage,
  getEvents,
  selectEvents,
  setDatetimeEvent,
  setStatusEvent,
  setDatetimeOrder,
  setPlatform,
  setAllUsers,
  eventList,
} from "../../redux/slices/events.js";
import { EventEdit } from "./EventEdit.js";
import { jsonEvent } from "../../components/Json.js";
import {
  redirectURL,
  defaultCreationDate,
  defaultEndDate,
  useInfiniteScroll,
  getEffectiveEventStatus,
  isRegistrationOpen,
} from "../../assets/functions.js";
import {
  canAccessAdminEventSections,
  canAccessEventEmails,
  canManageEvent,
} from "../../utils/eventPermissions.js";
import eventTypeImage01 from "../../assets/img/illustrations/International trade-bro.png";
import eventTypeImage02 from "../../assets/img/illustrations/Usability testing-bro.png";

const Events = () => {
  const dispatch = useAppDispatch();
  const selectEventsData = useAppSelector(selectEvents);
  const auth = useAuth();
  const [fonts, setFonts] = useState(false);
  const [aplicativos, setAplicativos] = useState(false);

  useEffect(() => {
    if (!fonts) {
      //Get google fonts
      axios
        .get(`/api/google/fonts`)
        .then((response) => {
          const formattedFonts = response.data.message.items.map((item) => ({
            value: item.family,
            label: item.family,
            font: item.family,
          }));
          setFonts(formattedFonts);
        })
        .catch((error) => {
          setFonts([]);
          console.log("Erro ao carregar fontes do Google Fonts:", error);
        });
    }
    if (!aplicativos) {
      axios
        .get("/api/application?status=1")
        .then(function (response) {
          setAplicativos(response["data"]["message"]);
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  }, [aplicativos, fonts]);

  // Separate effect for search/filter changes
  useEffect(() => {
    // Always dispatch, handling concurrency via requestId in Redux and aborting here
    const promise = dispatch(getEvents({ selectEventsData, auth }));

    return () => {
      promise.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectEventsData.updateID,
    selectEventsData.setID,
    selectEventsData.lastPage,
    selectEventsData.setTitleEvent,
    selectEventsData.setStatusEvent,
    selectEventsData.setDatetimeEvent,
    selectEventsData.platform,
    selectEventsData.allUsers,
    selectEventsData.setDatetimeOrder,
  ]);

  if (selectEventsData.setID > 0) {
    if (!fonts || !aplicativos || !selectEventsData.value?.evento_id) {
      return <Loader></Loader>;
    }

    // eslint-disable-next-line eqeqeq
    return (
      <EventEdit
        key="eventEdit"
        dataTable={selectEventsData.value}
        fonts={fonts}
        aplicativos={aplicativos}
        showHistory={selectEventsData.showHistory}
        showRecords={selectEventsData.showRecords}
        showEmails={selectEventsData.showEmails}
        showWhatsApp={selectEventsData.showWhatsApp}
        showRsvps={selectEventsData.showRsvps}
        showLogs={selectEventsData.showLogs}
      ></EventEdit>
    );
  }

  return (
    <EventList
      key="EventList"
      selectEventsData={selectEventsData}
    ></EventList>
  );
};

const EventList = ({ selectEventsData }) => {
  const dispatch = useAppDispatch();
  const userState = useAuth();
  const { setLoading, scrollContainerRef } = useLayout();
  const [showModalEventType, setShowModalEventType] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const notyf = useContext(NotyfContext);
  const showRecentesEvents =
    selectEventsData.eventsOpenedFull.length > 0 ? true : false;
  const isEventsLoading =
    selectEventsData.status === "loading" || !selectEventsData.value;

  useEffect(() => {
    if (!isRefreshing || selectEventsData.pageFetching) return;

    setLoading(false);
    setIsRefreshing(false);
  }, [isRefreshing, selectEventsData.pageFetching, setLoading]);

  const refreshEvents = () => {
    setIsRefreshing(true);
    setLoading(true);
    dispatch(eventList({ fetch: true, preserveCurrent: true }));
  };

  function createEvent(platform, modules, event_id = 0, selectedUser = 0) {
    let data;
    let json = jsonEvent(platform);
    if (modules) {
      if (platform === 2) {
        if (modules.includes("credentials")) {
          json.credentialAccess.status = true;
        } else {
          json.credentialAccess.status = false;
        }
        if (modules.includes("sympla")) {
          json.sympla.status = true;
        } else {
          json.sympla.status = false;
        }
        if (modules.includes("networking")) {
          json.networking.status = true;
        } else {
          json.networking.status = false;
        }
      }
      if (platform === 1) {
        if (modules.includes("applications")) {
          json.applications.status = true;
        } else {
          json.applications.status = false;
        }
      }
    }
    let jsonStr = JSON.stringify(json);

    if (platform === 1) {
      data = {
        user_id: selectedUser,
        titulo: "",
        descricao: "",
        json: jsonStr,
        status: 0,
        data_criacao: defaultCreationDate(),
        data_termino: defaultEndDate(),
        platform: platform,
        replicate_event_id: event_id,
      };
    } else {
      data = {
        user_id: selectedUser,
        title: "",
        description: "",
        json: jsonStr,
        status: 0,
        creation_date: defaultCreationDate(),
        end_date: defaultEndDate(),
        platform: platform,
        replicate_event_id: event_id,
      };
    }
    setLoading(true);
    axios
      .post("/api/event", data)
      .then(function (response) {
        let id = response.data.message.insertId;
        dispatch(setID({ id: id, platform: platform }));
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setLoading(false);
        notyf.open({
          type: "danger",
          message:
            error?.response?.data?.code === "INVALID_FORM_FIELD_VACANCY"
              ? error.response.data.message || "Revise os totais de vagas das opções."
              : "Houve um erro, tente novamente",
          ripple: true,
          dismissible: true,
        });
      });
  }

  useInfiniteScroll(
    scrollContainerRef,
    dispatch,
    setCurrentPage,
    selectEventsData,
  );

  return (
    <>
      <Button
        type="button"
        variant="primary"
        className="btn update-side-panel-button"
        onClick={refreshEvents}
        disabled={isRefreshing}
        title="Atualizar eventos"
        aria-label="Atualizar eventos"
      >
        <FontAwesomeIcon icon={faSync} spin={isRefreshing} size="lg" />
      </Button>
      <Container className="p-0 d-flex flex-column container h-100 w-100">
        <Row className="mx-0">
          <Col xs="auto" className="order-1 px-0 me-3">
            <Breadcrumb>
              <Breadcrumb.Item active>Eventos</Breadcrumb.Item>
            </Breadcrumb>
            <h6 className="text-muted mb-3">
              Gerenciamento e criação de eventos
            </h6>
          </Col>
          {/* Filters */}
          <Col
            xs="auto"
            className="order-sm-2 order-3 mb-3 px-0 ms-sm-auto ms-0"
          >
            <FilterDate />
            <FilterStatus selectEventsData={selectEventsData} />
            {(canManageEvent(userState, 1) || canManageEvent(userState, 2)) && (
                <Button
                  variant="primary"
                  className="shadow-sm"
                  onClick={() => setShowModalEventType(true)}
                >
                  <FontAwesomeIcon icon={faPlus} size="1x" />
                </Button>
              )}
          </Col>
        </Row>
        {isEventsLoading ? (
          <Loader></Loader>
        ) : (
          <>
            {showRecentesEvents && (
              <Row>
                <Col sm={12}>
                  <hr className="mt-0"></hr>
                  <h6 className="text-muted">
                    Acessados recentemente
                    <FontAwesomeIcon
                      icon={faClose}
                      className="float-end pointer"
                      size={"lg"}
                      onClick={(e) => dispatch(resetEventsOpenedFull())}
                    />
                  </h6>
                </Col>
                {selectEventsData.eventsOpenedFull.map((props, index) => {
                  return (
                    <EventCard
                      key={
                        "eventCard" +
                        (props.platform === 1 ? "platformX1" : "platformY2") +
                        props.evento_id +
                        selectEventsData.updateID
                      }
                      props={props}
                      registerToggle={registerToggle}
                      handleDelete={handleDelete}
                      handleEndEvent={handleEndEvent}
                    ></EventCard>
                  );
                })}
              </Row>
            )}
            {selectEventsData.draftEvents.length > 0 && (
              <Row>
                <Col sm={12}>
                  <hr className="mt-0"></hr>
                  <h6 className="text-muted">Rascunhos</h6>
                </Col>
                {selectEventsData.draftEvents.map((props, index) => {
                  return (
                    <EventCard
                      key={
                        "draftEventCard" +
                        (props.platform === 1 ? "platformX1" : "platformY2") +
                        props.evento_id +
                        selectEventsData.updateID
                      }
                      props={props}
                      registerToggle={registerToggle}
                      handleDelete={handleDelete}
                      handleEndEvent={handleEndEvent}
                    ></EventCard>
                  );
                })}
              </Row>
            )}
            <Row>
              <Col sm={12}>
                <hr className="mt-0"></hr>
                {showRecentesEvents && (
                  <h6 className="text-muted">Todos os eventos</h6>
                )}
              </Col>
              {selectEventsData.value && selectEventsData.value.length > 0 ? (
                <>
                  {selectEventsData.value.map((props, index) => {
                    return (
                      <EventCard
                        key={
                          "eventCard" +
                          (props.platform === 1 ? "platformM1" : "platformK2") +
                          props.evento_id +
                          selectEventsData.updateID
                        }
                        props={props}
                        registerToggle={registerToggle}
                        handleDelete={handleDelete}
                        handleEndEvent={handleEndEvent}
                      ></EventCard>
                    );
                  })}
                </>
              ) : (
                <div className="m-auto text-center mt-5">
                  <img
                    src={illustration}
                    alt="Searching"
                    className="img-fluid illustration-img mb-4"
                  />
                  <p className="opacity-75">
                    Não foi encontrado nenhum evento...
                  </p>
                </div>
              )}
            </Row>
            {!isRefreshing &&
              selectEventsData.value.length >= selectEventsData.limit &&
              selectEventsData.stopFetching === false && (
                <div
                  className={`container py-3 pageLoaderContainer ${selectEventsData.pageFetching === true ? "opacity-1" : "opacity-0"}`}
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1, transition: { duration: 0.5 } }}
                  exit={{ opacity: 0 }}
                >
                  <Loader></Loader>
                </div>
              )}
          </>
        )}
      </Container>
      <EventType
        eventGroup01={selectEventsData.eventGroup01}
        eventGroup02={selectEventsData.eventGroup02}
        usersList={selectEventsData.usersList}
        createEvent={createEvent}
        showModalEventType={showModalEventType}
        setShowModalEventType={setShowModalEventType}
      />
    </>
  );
};

const EventLogo = ({ props }) => {
  let origin = props.platform === 2 ? "plataforma-eventos" : "evento";
  let link = domainConfig.imageServer;
  if (!props.json) {
    return <></>;
  }

  const useCredentialAccessBranding =
    props.platform === 2 && props.json.networking?.status === false;
  const credentialPresentation =
    props.json.credentialAccess?.apresentation || null;
  const visualConfig = useCredentialAccessBranding && credentialPresentation
    ? {
      ...props.json,
      logo: credentialPresentation.logo || "",
      background: credentialPresentation.textSide?.background || props.json.background,
      transparency:
        credentialPresentation.register?.transparency ?? props.json.transparency,
      boxShadow: credentialPresentation.register?.boxShadow ?? props.json.boxShadow,
    }
    : props.json;

  const logoSrc =
    visualConfig.logo && visualConfig.logo !== ""
      ? `${link}/${origin}/${props.evento_id}/${visualConfig.logo}`
      : "";

  const handleError = (e) => {
    e.target.onerror = null;
    e.target.style.opacity = "0";
  };

  function handleStyle(visualProps, evento_id) {
    if (visualProps.background.type === "image") {
      const bgUrl =
        visualProps.background.url && visualProps.background.url !== ""
          ? `${link}/${origin}/${evento_id}/${visualProps.background.url}`
          : imageNotFound;
      return {
        background: `url(${bgUrl}) no-repeat center center / cover`,
        height: "100%",
      };
    } else if (visualProps.background.type === "video") {
      return {
        background: `url(${link + "/" + origin + "/" + evento_id + "/" + visualProps.background.url}) no-repeat center center / cover`,
        height: "100%",
      };
    } else {
      if (!visualProps.logo || visualProps.logo === "") {
        return {
          background: `url(${imageNotFound}) no-repeat center center / cover`,
          height: "100%",
        };
      }
      return {
        backgroundColor: `${visualProps.background.color}`,
      };
    }
  }

  if (visualConfig.background.type === "video") {
    return (
      <div className="position-relative d-flex">
        <video
          className="videoBackground"
          autoPlay
          loop
          muted
          playsInline
          src={`${link + "/" + origin + "/" + props.evento_id + "/" + visualConfig.background.url}`}
        ></video>
        <div style={{ padding: "25px 50px", zIndex: 1, width: "100%" }}>
          <div
            style={{
              backgroundColor: visualConfig.transparency,
              boxShadow: "0 .2rem 0.75rem " + visualConfig.boxShadow,
              borderRadius: "5px",
            }}
          >
            <img
              className="card-img-top"
              src={logoSrc}
              onError={handleError}
              alt="logo-evento"
            ></img>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div style={handleStyle(visualConfig, props.evento_id)}>
        <div style={{ padding: "25px 50px", zIndex: 1, width: "100%" }}>
          <div
            style={{
              backgroundColor: visualConfig.transparency,
              boxShadow: "0 .2rem 0.75rem " + visualConfig.boxShadow,
              borderRadius: "5px",
            }}
          >
            <img
              className="card-img-top"
              src={logoSrc}
              onError={handleError}
              alt="logo-evento"
            ></img>
          </div>
        </div>
      </div>
    );
  }
};

/**
 * Returns an array of warning objects for an event card.
 * Each warning: { type, icon, title, description, action }
 * Add new condition blocks here as more warning types are needed.
 */
const getCardWarnings = (props, userState) => {
  const warnings = [];

  // 1. Logs (Error level)
  if (canAccessAdminEventSections(userState, props.platform) && props["total_notificacoes"] > 0) {
    warnings.push({
      type: "logs",
      icon: faBell,
      title: "Notificações de erro",
      description: props["total_notificacoes"] > 1 ? `Existem ${props["total_notificacoes"]} notificações de erro aguardando revisão.` : "Existe 1 notificação de erro aguardando revisão.",
    });
  }

  // 2. Customização do evento incompleta
  if (props.status === 0 || props.status === 1) {
    warnings.push({
      type: "design",
      icon: faImage,
      title: "Customização do evento incompleta",
      description: "A configuração do evento não foi finalizada.",
    });
  }

  // 3. Atualização de Aplicativo Pendente (apenas plataforma 1)
  if (props.platform === 1) {
    const appDetails = Array.isArray(props.app_details)
      ? props.app_details
      : typeof props.app_details === "string"
        ? JSON.parse(props.app_details)
        : [];

    const appsToUpdate = appDetails.filter(
      (app) => app.currentVersion && app.version != app.currentVersion && app.version !== "toUpdate"
    );

    if (appsToUpdate.length > 0) {
      warnings.push({
        type: "update",
        icon: faRotateLeft,
        title: "Atualização de Aplicativo Pendente",
        description: `Existem ${appsToUpdate.length} aplicativo(s) com novas versões disponíveis para atualização.`,
      });
    }
  }

  // 4. Alerta de Lotação
  const limitStatus = props.json?.subscriptionLimit?.status;
  const limitValue = parseInt(props.json?.subscriptionLimit?.limit) || 0;
  const totalParticipants = parseInt(props["total_participantes"]) || 0;

  if (limitStatus === true && limitValue > 0) {
    const percentage = (totalParticipants / limitValue) * 100;
    if (percentage >= 80) {
      warnings.push({
        type: "capacity",
        icon: faUser,
        title: "Alerta de Lotação",
        description: `As inscrições atingiram ${percentage.toFixed(0)}% da capacidade máxima (${totalParticipants} de ${limitValue}).`,
      });
    }
  }

  // 5. Todas as vagas das opções de um campo foram preenchidas
  const vacancyRows = Array.isArray(props.form_field_vacancies)
    ? props.form_field_vacancies
    : typeof props.form_field_vacancies === "string"
      ? (() => {
        try {
          const parsedRows = JSON.parse(props.form_field_vacancies);
          return Array.isArray(parsedRows) ? parsedRows : [];
        } catch (error) {
          return [];
        }
      })()
      : [];
  const controlledFields = Array.isArray(props.json?.form?.fields)
    ? props.json.form.fields.filter(
      (field) => field?.type === "select" && field?.vacancyEnabled === true,
    )
    : [];

  controlledFields.forEach((field) => {
    const fieldOptions = (Array.isArray(field.options) ? field.options : [])
      .map((option) => String(option ?? "").trim())
      .filter((option, index, options) => option && options.indexOf(option) === index);
    if (fieldOptions.length === 0) return;

    const configuredOptions = new Map(
      vacancyRows
        .filter((row) => String(row?.field_id ?? row?.fieldId) === String(field.inputID))
        .map((row) => [String(row?.option_value ?? row?.option ?? "").trim(), row]),
    );

    const fullOptions = fieldOptions.map((option) => {
      const row = configuredOptions.get(option);
      if (!row) return null;

      const totalAvailable = Number(row.total_available ?? row.totalAvailable);
      const hasUsed = row.used !== undefined && row.used !== null;
      const used = hasUsed
        ? Number(row.used)
        : row.remaining !== undefined && row.remaining !== null
          ? totalAvailable - Number(row.remaining)
          : NaN;

      return Number.isFinite(totalAvailable) && totalAvailable > 0
        && Number.isFinite(used) && used >= totalAvailable
        ? totalAvailable
        : null;
    });

    if (fullOptions.every((totalAvailable) => totalAvailable !== null)) {
      const fieldName = field.label || field.title || field.name || field.inputID;
      const totalAvailable = fullOptions.reduce((sum, value) => sum + value, 0);
      warnings.push({
        type: "field-capacity",
        icon: faListCheck,
        title: "Controle de vagas",
        description: `Todas as vagas disponíveis (${totalAvailable}) foram preenchidas para o campo "${fieldName}".`,
      });
    }
  });

  // 6. Vínculo de Expositor ausente
  if (props.platform === 2 && props.unlinked_exhibitors > 0) {
    warnings.push({
      type: "exhibitor",
      icon: faStore,
      title: "Expositores sem vínculo",
      description: `Existem ${props.unlinked_exhibitors} usuário(s) do tipo expositor sem um estande/expositor associado a sua conta.`,
    });
  }

  // 7. Responsavel da transmissao ausente
  if (props.platform === 2 && props.unassigned_streamings > 0) {
    warnings.push({
      type: "streaming",
      icon: faVideo,
      title: "Transmissões sem responsável",
      description: `Existem ${props.unassigned_streamings} transmissão(ões) sem usuário responsável associado.`,
    });
  }

  // 8. Emails duplicados (apenas plataforma 2)
  if (canAccessEventEmails(userState, props.platform) && props.duplicate_emails_count > 0) {
    warnings.push({
      type: "duplicates",
      icon: faUserXmark,
      title: "Emails Duplicados",
      description: `Existem ${props.duplicate_emails_count} email(s) duplicados entre os participantes deste evento.`,
    });
  }

  // 9. Falha na integração Sympla (apenas plataforma 2)
  if (
    props.platform === 2 &&
    props.json?.sympla?.status &&
    (props.json?.sympla?.sync_status === "error" || props.json?.sympla?.sync_paused === true)
  ) {
    warnings.push({
      type: "sympla",
      icon: faExclamationTriangle,
      title: "Falha na integração Sympla",
      description:
        props.json?.sympla?.last_error ||
        "A sincronização com a Sympla foi pausada devido a uma falha de autenticação (chave inválida ou expirada).",
    });
  }

  return warnings;
};

const EventCard = ({ props, registerToggle, handleDelete, handleEndEvent }) => {
  const { setLoading } = useLayout();
  const dispatch = useAppDispatch();
  const selectEventsData = useAppSelector(selectEvents);
  const userState = useAuth();
  const notyf = useContext(NotyfContext);
  const [showCustomizationModal, setShowCustomizationModal] = useState(false);
  const [showWarningsModal, setShowWarningsModal] = useState(false);
  const canManageCurrentEvent = canManageEvent(userState, props.platform);
  const canAccessAdminSections = canAccessAdminEventSections(userState, props.platform);
  const canAccessEmails = canAccessEventEmails(userState, props.platform);
  const cardWarnings = getCardWarnings(props, userState);
  const effectiveStatus = getEffectiveEventStatus(
    props.status,
    Number(props.platform) === 1
      ? props.data_termino
      : props.end_date || props.data_termino,
  );
  const cardColor = colorsX[effectiveStatus] || props.cor;
  const registrationIsOpen = isRegistrationOpen(
    props.json?.form?.status,
    props.json?.form?.register_end_date,
  );

  return (
    <Col md="6" lg="6" sm="12" xl="4" className="mb-4 d-flex align-items-stretch">
      <Card className="mainCard w-100 mb-0">
        <div
          className={`card-top justify-content-between bg-${cardColor} text-${cardColor === "primary" ? "dark" : "white"} d-flex`}
        >
          <span className={`fw-bold ms-1 d-flex align-items-center gap-2 me-auto compact-text`}>
            {statusX[effectiveStatus] || props["statusString"]}
          </span>

          <div className="px-3 compact-text">
            <OverlayTrigger overlay={<Tooltip>Total de participantes</Tooltip>}>
              <span className="fw-bold cursor pointer">
                <FontAwesomeIcon icon={faUser} className="me-1" />
                {props["total_participantes"]}
              </span>
            </OverlayTrigger>

            {props.platform === 1 && (
              <>
              </>
            )}
            {props.platform === 2 && (
              <>
                {props.json?.credentialAccess?.status && (
                  <OverlayTrigger overlay={<Tooltip>Participantes com check-in</Tooltip>}>
                    <span className="fw-bold ms-3 cursor pointer">
                      <FontAwesomeIcon icon={faCircleCheck} className="me-1" />
                      {props["total_checkins"] > 0 ? props["total_checkins"] : 0}
                    </span>
                  </OverlayTrigger>
                )}
                {canAccessEmails && (
                  <OverlayTrigger overlay={<Tooltip>Total de e-mails enviados/agendados</Tooltip>}>
                    <span className="fw-bold ms-3 cursor pointer">
                      <FontAwesomeIcon icon={faEnvelope} className="me-1" />
                      {props["total_emails"] > 0 ? props["total_emails"] : 0}
                    </span>
                  </OverlayTrigger>
                )}
              </>
            )}
          </div>
          <div className="d-inline float-end d-flex align-items-center gap-1">
            <Dropdown>
              <Dropdown.Toggle
                className={`text-${cardColor === "primary" ? "dark" : "white"} dropdownEvent py-0`}
                variant="transparent"
              />
              <Dropdown.Menu>
                {props.platform === 2 && (
                  <Dropdown.Item
                    onClick={() => {
                      dispatch(
                        setID({
                          id: props.evento_id,
                          platform: props.platform,
                          showRecords: true,
                        }),
                      );
                    }}
                  >
                    Visualizar registros
                  </Dropdown.Item>
                )}
                {canManageCurrentEvent && (
                  <>
                {props.platform === 2 && <Dropdown.Divider />}
                <li>
                  <h6 className="dropdown-header">Links</h6>
                </li>
                {props.platform === 1 && (
                  <Dropdown.Item
                    eventKey="6"
                    onClick={() => {
                      redirectURL(
                        true,
                        domainConfig.aplicativos + "/?token=" + props.token,
                      );
                    }}
                  >
                    <FontAwesomeIcon icon={faExternalLinkAlt} className="me-1" />
                    Acessar evento
                  </Dropdown.Item>
                )}
                {props.platform === 2 && props.json?.networking?.status && (
                  <Dropdown.Item
                    eventKey="6"
                    onClick={() => {
                      redirectURL(
                        true,
                        domainConfig.eventos + "/?token=" + props.token,
                      );
                    }}
                  >
                    <FontAwesomeIcon icon={faExternalLinkAlt} className="me-1" />
                    Acessar evento
                  </Dropdown.Item>
                )}

                {props.platform === 2 &&
                  props.json?.credentialAccess?.status && (
                    <>
                      <Dropdown.Item
                        eventKey="7"
                        onClick={() => {
                          redirectURL(
                            true,
                            domainConfig.credenciamento +
                            "/login?token=" +
                            props.token +
                            "&access_code=" +
                            props.codigo_credenciamento,
                          );
                        }}
                      >
                        <FontAwesomeIcon
                          icon={faExternalLinkAlt}
                          className="me-1"
                        />
                        Acessar credenciamento
                      </Dropdown.Item>
                    </>
                  )}

                {props.platform === 1 && (
                  <Dropdown.Item
                    eventKey="8"
                    onClick={() => {
                      redirectURL(
                        true,
                        domainConfig.aplicativos +
                        "/?token=" +
                        props.token +
                        "&presenter=" +
                        props.codigo_presenter,
                      );
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faPersonChalkboard}
                      className="me-1"
                    />
                    Acessar modo apresentador
                  </Dropdown.Item>
                )}
                {props.platform === 1 && (
                  <Dropdown.Item
                    eventKey="9"
                    onClick={() => {
                      setShowCustomizationModal(true);
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faPersonChalkboard}
                      className="me-1"
                    />
                    Acessar tela do modo de apresentação
                  </Dropdown.Item>
                )}
                <Dropdown.Divider />
                <li>
                  <h6 className="dropdown-header">Ações</h6>
                </li>
                {Number(effectiveStatus) === 2 && (
                    <>
                      {registrationIsOpen ? (
                        <Dropdown.Item
                          eventKey="1"
                          onClick={() =>
                            registerToggle(
                              props,
                              false,
                              props.platform,
                              setLoading,
                              notyf,
                              dispatch,
                              eventList,
                            )
                          }
                        >
                          Desativar inscrições
                        </Dropdown.Item>
                      ) : (
                        <Dropdown.Item
                          eventKey="2"
                          onClick={() =>
                            registerToggle(
                              props,
                              true,
                              props.platform,
                              setLoading,
                              notyf,
                              dispatch,
                              eventList,
                            )
                          }
                        >
                          Ativar inscrições
                        </Dropdown.Item>
                      )}
                      <Dropdown.Item
                        eventKey="3"
                        onClick={() =>
                          handleEndEvent(
                            props,
                            props.platform,
                            setLoading,
                            notyf,
                            dispatch,
                            eventList,
                          )
                        }
                      >
                        Finalizar evento
                      </Dropdown.Item>
                    </>
                  )}
                <Dropdown.Item
                  eventKey="4"
                  onClick={() =>
                    handleDelete(
                      props,
                      props.platform,
                      setLoading,
                      notyf,
                      dispatch,
                      eventList,
                    )
                  }
                >
                  Excluir evento
                </Dropdown.Item>
                  </>
                )}

              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>
        {/* Warning alert icon — only shown when there are warnings */}
        {cardWarnings.length > 0 && (
          <button
            className={`eventCardWarningBtn bg-${cardColor} text-${cardColor === "primary" ? "dark" : "white"}`}
            title={`${cardWarnings.length} alerta(s) para este evento`}
            onClick={(e) => {
              e.stopPropagation();
              setShowWarningsModal(true);
            }}
          >
            <FontAwesomeIcon icon={faExclamationTriangle} />
            <span className="eventCardWarningCount">{cardWarnings.length}</span>
          </button>
        )}
        <div
          className="clickMainCard d-flex flex-column flex-grow-1"
          onClick={() => {
            if (canManageCurrentEvent) {
              dispatch(
                setID({ id: props.evento_id, platform: props.platform }),
              );
            } else {
              dispatch(
                setID({
                  id: props.evento_id,
                  platform: props.platform,
                  showHistory: true,
                }),
              );
            }
          }}
        >
          <div className="position-relative">
            <EventLogo props={props}></EventLogo>
          </div>
          <div className="border-top eventCardBody d-flex flex-column flex-grow-1">
            {/* Title row with platform icon */}
            <div className="eventCardTitleRow">
              <span className="eventCardPlatformIcon">
                <FontAwesomeIcon icon={props.platform === 1 ? faDisplay : faAddressCard} />
              </span>
              <p className="fw-bold mb-0 eventCardTitle">
                {props.titulo !== "" ? props["titulo"] : "Sem título"}
              </p>
            </div>

            {/* Badges */}
            {((props["app_details"] && props["app_details"].length > 0) ||
              (props.platform === 2 && (props.json.credentialAccess?.status || props.json.sympla?.status || props.json.networking?.status))) && (
                <div className="eventCardBadges">
                  {props["app_details"] &&
                    props["app_details"].length > 0 &&
                    props["app_details"].map((value, index) => (
                      <Badge
                        key={"badge" + props.evento_id + selectEventsData.updateID + "index" + index}
                        bg={cardColor}
                        className={`me-1 mb-1 text-${cardColor === "primary" ? "dark" : "white"}`}
                      >
                        <FontAwesomeIcon icon={faDiamond} className="me-1" />
                        {value.nomeAplicativo}
                      </Badge>
                    ))}
                  {props.platform === 2 && (
                    <>
                      {props.json.credentialAccess?.status && (
                        <Badge bg={cardColor} className={`me-1 mb-1 text-${cardColor === "primary" ? "dark" : "white"}`}>
                          <FontAwesomeIcon icon={faCircleCheck} className="me-1" />Credenciamento
                        </Badge>
                      )}
                      {props.json.sympla?.status && (
                        <Badge bg={cardColor} className={`me-1 mb-1 text-${cardColor === "primary" ? "dark" : "white"}`}>
                          <FontAwesomeIcon icon={faCircleCheck} className="me-1" />Sympla
                        </Badge>
                      )}
                      {props.json.networking?.status && (
                        <Badge bg={cardColor} className={`me-1 mb-1 text-${cardColor === "primary" ? "dark" : "white"}`}>
                          <FontAwesomeIcon icon={faCircleCheck} className="me-1" />Networking
                        </Badge>
                      )}
                    </>
                  )}
                </div>
              )}

            {/* Two-column meta table */}
            <dl className="eventCardMeta mb-auto">
              {/* Row 1: Token | Inscrições */}
              <div className="eventCardMetaRow">
                <dt>Token</dt>
                <dd>{props.token}</dd>
              </div>
              <div className="eventCardMetaRow">
                <dt>Inscrições</dt>
                <dd>{registrationIsOpen ? "Em aberto" : "Encerrado"}</dd>
              </div>
              {/* Row 2: Período (spans both columns) */}
              <div className="eventCardMetaRow eventCardMetaRowFull">
                <dt>Período</dt>
                <dd>{props.data_criacao_formatted} → {props.data_termino_formatted}</dd>
              </div>
              {userState.user_id !== props.user_id && (
                <div className="eventCardMetaRow eventCardMetaRowFull">
                  <dt>Criado por</dt>
                  <dd>{props.email}</dd>
                </div>
              )}
            </dl>
          </div>
        </div>
      </Card>
      <CustomizationModal
        showCustomizationModal={showCustomizationModal}
        setShowCustomizationModal={setShowCustomizationModal}
        props={props}
        notyf={notyf}
      />
      <EventWarningsModal
        show={showWarningsModal}
        onHide={() => setShowWarningsModal(false)}
        warnings={cardWarnings}
        props={props}
        dispatch={dispatch}
        canAccessAdminSections={canAccessAdminSections}
        canAccessEmails={canAccessEmails}
        canManageCurrentEvent={canManageCurrentEvent}
      />
    </Col>
  );
};

/** Modal that lists all active warnings for a card */
const EventWarningsModal = ({
  show,
  onHide,
  warnings,
  props,
  dispatch,
  canAccessAdminSections,
  canAccessEmails,
  canManageCurrentEvent,
}) => {
  const canOpenWarning = (type) =>
    (type === "logs" && canAccessAdminSections) ||
    (type === "emails" && canAccessEmails) ||
    (type === "sympla" && (canManageCurrentEvent || canAccessAdminSections));

  return (
    <Modal
      show={show}
      size={"md"}
      fullscreen={"sm-down"}
      onHide={onHide}
      centered
      backdrop
      scrollable
    >
      <Modal.Header closeButton>
        <Modal.Title>Alertas do evento</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form.Group>
          <div className="list-group">
            {warnings.map((warning, index) => (
              <div
                key={"warning" + index}
                className={`list-group-item mb-2 py-3 px-3 ${canOpenWarning(warning.type) ? "list-group-item-action" : ""}`}
                aria-current="true"
                style={{ cursor: canOpenWarning(warning.type) ? "pointer" : "default" }}
                onClick={() => {
                  if (warning.type === "logs" && canAccessAdminSections) {
                    onHide();
                    dispatch(
                      setID({
                        id: props.evento_id,
                        platform: props.platform,
                        showLogs: true,
                      }),
                    );
                  } else if (warning.type === "emails" && canAccessEmails) {
                    onHide();
                    dispatch(
                      setID({
                        id: props.evento_id,
                        platform: props.platform,
                        showEmails: true,
                      }),
                    );
                  } else if (warning.type === "sympla") {
                    onHide();
                    if (canManageCurrentEvent) {
                      dispatch(
                        setID({
                          id: props.evento_id,
                          platform: props.platform,
                        }),
                      );
                    } else if (canAccessAdminSections) {
                      dispatch(
                        setID({
                          id: props.evento_id,
                          platform: props.platform,
                          showLogs: true,
                        }),
                      );
                    }
                  }
                }}
              >
                <div className="d-flex w-100 align-items-center">
                  <div className="me-3">
                    <FontAwesomeIcon
                      icon={warning.icon}
                      size="2x"
                      className={`text-${props["cor"] === "primary" ? "dark" : props["cor"]}`}
                    />
                  </div>
                  <div>
                    <h5 className="mb-0">{warning.title}</h5>
                    <small className="text-muted">{warning.description}</small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Form.Group>
      </Modal.Body>
    </Modal>
  );
};

export const EventType = ({
  eventGroup01,
  eventGroup02,
  usersList,
  createEvent,
  showModalEventType,
  setShowModalEventType,
}) => {
  const userState = useAuth();
  const [selectedPlatform, setSelectedPlatform] = useState(null);
  const [selectedEvent, setSelectedEvent] = useState(null);
  const [selectedUser] = useState(userState.user_id);
  const [showModulesList, setShowModulesList] = useState(null);
  const [selectedModules, setSelectedModules] = useState([]);
  const [showStep, setShowStep] = useState(0);
  const notyf = useContext(NotyfContext);

  const toggleModule = (moduleId) => {
    setSelectedModules((prevModules) => {
      if (prevModules.includes(moduleId)) {
        return prevModules.filter((module) => module !== moduleId);
      } else {
        return [...prevModules, moduleId];
      }
    });
  };

  const handleCreateEvent = () => {
    if (!showModulesList && !selectedEvent) {
      notyf.open({
        type: "danger",
        message: "Selecione um evento para continuar",
        ripple: true,
        dismissible: true,
      });
      return;
    }
    createEvent(
      selectedPlatform,
      selectedModules,
      selectedEvent,
      selectedUser,
    );
    resetModal();
  };

  const handleBack = () => {
    if (showStep === 2) {
      setSelectedEvent(null);
      setSelectedModules([]);
      setShowModulesList(false);
    } else {
      setSelectedEvent(null);
      setSelectedModules([]);
      setShowModulesList(false);
      setSelectedPlatform(null);
    }
    setShowStep((prevState) => prevState - 1);
  };

  const resetModal = () => {
    setSelectedPlatform(null);
    setSelectedModules([]);
    setShowStep(0);
    setShowModalEventType(false);
  };

  return (
    <>
      <Modal
        show={showModalEventType}
        size={"md"}
        fullscreen={"sm-down"}
        onHide={resetModal}
        centered
        backdrop
      >
        <Modal.Header closeButton>
          <Modal.Title>Criar evento</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group>
            {showStep === 0 && (
              <div className="row mx-0">
                {canManageEvent(userState, 1) && (
                  <div
                    className="gameTypeMode col-md-12 my-2"
                    onClick={() => {
                      setSelectedPlatform(1);
                      setShowStep(1);
                    }}
                  >
                    <div className="gameTypeModeIcon">
                      <div className="text-dark bg-light">
                        <img src={eventTypeImage01} alt="event image1"></img>
                      </div>
                    </div>
                    <div className="gameTypeModeLabel">
                      <h5>
                        <FontAwesomeIcon
                          size={"lg"}
                          icon={faDisplay}
                          className="me-2"
                        />
                        {eventX[0]}
                      </h5>
                      <span className="mb-0">
                        Crie um evento e selecione aplicações para serem
                        utilizadas! Compartilhe o link para qualquer pessoa
                        acessar e participar
                      </span>
                    </div>
                  </div>
                )}
                {canManageEvent(userState, 2) && (
                  <div
                    className="gameTypeMode col-md-12 my-2"
                    onClick={() => {
                      setSelectedPlatform(2);
                      setShowStep(1);
                    }}
                  >
                    <div className="gameTypeModeIcon">
                      <div className="text-dark bg-light">
                        <img src={eventTypeImage02} alt="event image2"></img>
                      </div>
                    </div>
                    <div className="gameTypeModeLabel">
                      <h5>
                        <FontAwesomeIcon
                          size={"lg"}
                          icon={faAddressCard}
                          className="me-2"
                        />
                        {eventX[1]}
                      </h5>
                      <span className="mb-0">
                        Aproveite os benefícios de uma aplicação personalizada
                        para divulgação e controle do evento e permita que
                        participantes se conectem com mais facilidade
                      </span>
                    </div>
                  </div>
                )}
              </div>
            )}

            {showStep === 1 && (
              <div className="row mx-0">
                <div
                  className="gameTypeMode col-md-12 my-2"
                  onClick={() => {
                    setShowStep(2);
                    setShowModulesList(true);
                  }}
                >
                  <div className="gameTypeModeIcon p-2">
                    <div className="text-dark bg-primary">
                      <FontAwesomeIcon size={"2x"} icon={faSquarePlus} />
                    </div>
                  </div>
                  <div className="gameTypeModeLabel">
                    <h5 className="mb-0"> Novo evento</h5>
                  </div>
                </div>
                <div
                  className="gameTypeMode col-md-12 my-2"
                  onClick={() => setShowStep(2)}
                >
                  <div className="gameTypeModeIcon p-2">
                    <div className="text-dark bg-primary">
                      <FontAwesomeIcon size={"2x"} icon={faClone} />
                    </div>
                  </div>
                  <div className="gameTypeModeLabel">
                    <h5 className="mb-0">Replicar evento existente</h5>
                  </div>
                </div>
              </div>
            )}
            {showStep === 2 &&
              (showModulesList ? (
                <div className="row mx-0">
                  {selectedPlatform === 1 ? (
                    <>
                      <Form.Label>Configurar módulos</Form.Label>
                      <div
                        className="gameTypeMode col-md-12 mb-2 mt-0"
                        onClick={() => toggleModule("applications")}
                      >
                        <div className="gameTypeModeLabel">
                          <Form.Check
                            type="checkbox"
                            checked={selectedModules.includes("applications")}
                            onChange={() => toggleModule("applications")}
                            label="Aplicativos"
                            className="mb-0"
                          />
                        </div>
                      </div>
                    </>
                  ) : (
                    <>
                      <Form.Label>Configurar módulos</Form.Label>
                      <div
                        className="gameTypeMode col-md-12 mb-1 mt-0"
                        onClick={() => toggleModule("networking")}
                      >
                        <div className="gameTypeModeLabel">
                          <Form.Check
                            type="checkbox"
                            checked={selectedModules.includes("networking")}
                            onChange={() => toggleModule("networking")}
                            label="Networking"
                            className="mb-0"
                          />
                        </div>
                      </div>
                      <div
                        className="gameTypeMode col-md-12 my-1"
                        onClick={() => toggleModule("credentials")}
                      >
                        <div className="gameTypeModeLabel">
                          <Form.Check
                            type="checkbox"
                            checked={selectedModules.includes("credentials")}
                            onChange={() => toggleModule("credentials")}
                            label="Credenciamento"
                            className="mb-0"
                          />
                        </div>
                      </div>
                      <div
                        className="gameTypeMode col-md-12 my-1"
                        onClick={() => toggleModule("sympla")}
                      >
                        <div className="gameTypeModeLabel">
                          <Form.Check
                            type="checkbox"
                            checked={selectedModules.includes("sympla")}
                            onChange={() => toggleModule("sympla")}
                            label="Sympla"
                            className="mb-0"
                          />
                        </div>
                      </div>
                    </>
                  )}
                </div>
              ) : (
                <div className="row">
                  {selectedPlatform === 1 ? (
                    <div className="mb-3">
                      <Form.Label>Lista de eventos existentes</Form.Label>
                      <Select
                        className="px-0"
                        options={eventGroup01}
                        getOptionLabel={(option) => option.titulo}
                        getOptionValue={(option) => option.evento_id}
                        onChange={(option) => {
                          setSelectedEvent(option.evento_id);
                        }}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            padding: 5,
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        menuPortalTarget={document.body}
                        placeholder={"Clique para selecionar..."}
                      />
                      <Form.Text>
                        (Componentes e participantes são mantidos mas o
                        históricos relacionados aos participantes ou de uso são
                        resetados)
                      </Form.Text>
                    </div>
                  ) : (
                    <div className="mb-3">
                      <Form.Label>Lista de eventos existentes</Form.Label>
                      <Select
                        className="px-0"
                        options={eventGroup02}
                        getOptionLabel={(option) => option.title}
                        getOptionValue={(option) => option.event_id}
                        onChange={(option) => {
                          setSelectedEvent(option.event_id);
                        }}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            padding: 5,
                          }),
                          menu: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                          menuPortal: (provided) => ({
                            ...provided,
                            zIndex: 9999,
                          }),
                        }}
                        menuPortalTarget={document.body}
                        placeholder={"Clique para selecionar..."}
                      />
                      <Form.Text>
                        (Componentes e participantes são mantidos mas o
                        históricos relacionados aos participantes ou de uso são
                        resetados)
                      </Form.Text>
                    </div>
                  )}
                </div>
              ))}

          </Form.Group>
        </Modal.Body>
        {showStep > 0 && (
          <Modal.Footer>
            <Button variant="secondary" onClick={handleBack}>
              Voltar
            </Button>
            {showStep > 1 && (
              <Button variant="primary" onClick={handleCreateEvent}>
                Continuar
              </Button>
            )}
          </Modal.Footer>
        )}
      </Modal>
    </>
  );
};

export const FilterDate = () => {
  const dispatch = useAppDispatch();
  const selectEventsData = useAppSelector(selectEvents);
  const userState = useAuth();
  const showUserScope = Number(userState?.tipo) === 1;

  const filtersDate = [
    { text: "Todos os eventos", value: 0 },
    { text: "Nos últimos 30 dias", value: 1 },
    { text: "Nos últimos 90 dias", value: 2 },
  ];
  const filtersOrder = [
    { text: "Mais recentes", value: 0 },
    { text: "Mais antigos", value: 1 },
  ];
  const filtersPlatform = [
    { text: "Todas as plataformas", value: 0 },
    { text: "Plataforma de aplicativos", value: 1 },
    { text: "Plataforma de eventos", value: 2 },
  ];

  return (
    <Dropdown className="d-inline me-2">
      <Dropdown.Toggle className="btn-primary">
        {filtersPlatform.find((f) => f.value === selectEventsData.platform)
          ?.text ?? "Todas as plataformas"}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {filtersDate.map((item, index) => (
          <Dropdown.Item
            className={selectEventsData.setDatetimeEvent === item.value ? "active" : ""}
            key={"date" + index}
            onClick={() => dispatch(setDatetimeEvent(item.value))}
          >
            {item.text}
          </Dropdown.Item>
        ))}
        <Dropdown.Divider />
        {filtersOrder.map((item, index) => (
          <Dropdown.Item
            className={selectEventsData.setDatetimeOrder === item.value ? "active" : ""}
            key={"order" + index}
            onClick={() => dispatch(setDatetimeOrder(item.value))}
          >
            {item.text}
          </Dropdown.Item>
        ))}
        <Dropdown.Divider />
        {filtersPlatform.map((item, index) => (
          <Dropdown.Item
            className={selectEventsData.platform === item.value ? "active" : ""}
            key={"platformX" + index}
            onClick={() => dispatch(setPlatform(item.value))}
          >
            {item.text}
          </Dropdown.Item>
        ))}
        {showUserScope && (
          <>
            <Dropdown.Divider />
            <Dropdown.Item
              className={!selectEventsData.allUsers ? "active" : ""}
              onClick={() => dispatch(setAllUsers(false))}
            >
              Meus eventos
            </Dropdown.Item>
            <Dropdown.Item
              className={selectEventsData.allUsers ? "active" : ""}
              onClick={() => dispatch(setAllUsers(true))}
            >
              Eventos de todos os usuários
            </Dropdown.Item>
          </>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export const FilterStatus = ({ selectEventsData }) => {
  const dispatch = useAppDispatch();

  function handleFilterStatus(status) {
    const currentStatus = selectEventsData.setStatusEvent.map((x) => ({
      ...x,
      isActive: x.value === status ? !x.isActive : x.isActive,
    }));
    dispatch(setStatusEvent(currentStatus));
  }

  return (
    <Dropdown className="d-inline me-2">
      <Dropdown.Toggle variant="primary" className="shadow-sm">
        <FontAwesomeIcon
          icon={faFilter}
          className="align-middle me-1"
          size="lg"
        />
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {selectEventsData.setStatusEvent.map((value, index) => {
          return (
            <Dropdown.Item
              className={value.isActive ? "active" : ""}
              key={index + "active"}
              onClick={() => {
                handleFilterStatus(value.value);
              }}
            >
              {value.text}
            </Dropdown.Item>
          );
        })}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default Events;
